import React from 'react';
import { Outlet } from 'react-router-dom';
import { Spinner } from '@danfoss/webex-ui';
import { isContentOnly } from '../../utils';
import Header from '../Header/Header';
import { useAuthentication } from '../../Providers/AuthenticationProvider';

export const MainLayout = () => {
  const { loading } = useAuthentication();

  if (loading) {
    return <Spinner visible />;
  }

  return (
    <>
      {!isContentOnly() && <Header />}
      <Outlet />
    </>
  );
};
